/* eslint no-console:0 */

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)
// Process all images to add them to manifest
images.keys().forEach(images)

import moment from 'moment'
window.moment = moment

// import "@hotwired/turbo-rails"

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"

Rails.start()
ActiveStorage.start()

require("channels")

import "trix"
import "@rails/actiontext"
import "../stylesheets/actiontext.scss"

import 'intl-tel-input/build/css/intlTelInput.css'
import "../stylesheets/custom.scss"
import "../stylesheets/landing.scss"


import "controllers"

import Tagify from '@yaireo/tagify'
import "@yaireo/tagify/dist/tagify.css"


import "javascripts/research_view"
import "../javascripts/subscription_form_view"
import "javascripts/helpers/confirmation_handler"

import "chartkick/chart.js"


import "javascripts/theme/vendor-all.min.js"
import "javascripts/theme/plugins/bootstrap.min.js"
import "javascripts/theme/plugins/pcoded.min.js"

import { Tooltip, Dropdown, Tab, Modal } from "javascripts/theme/plugins/bootstrap.min.js"
window.bootstrap = { Modal };

import "noty/src/noty.scss";
import "noty/src/themes/mint.scss";

import Noty from "noty"
window.Noty = Noty;


import ahoy from "ahoy.js"
ahoy.trackView();
// ahoy.trackClicks("a, button, input[type=submit]");
// ahoy.trackSubmits("form");
// ahoy.trackChanges("input, textarea, select");

document.addEventListener("DOMContentLoaded", ()=> {
  const buttons = Array.from(document.querySelectorAll('.copy-btn'));
  buttons.forEach((btn)=> {
    btn.addEventListener('click', (ev)=> {
      ev.preventDefault();

      const srcEl = document.querySelector(ev.currentTarget.dataset.clipboardTarget);
      const text = srcEl.innerText.trim();

      const textNode = document.createElement("input");
      textNode.setAttribute("value", text);
      document.body.appendChild(textNode);
      textNode.select();
      document.execCommand("copy");
      document.body.removeChild(textNode);
    })
  });


  const tag_inputs = document.querySelectorAll("[data-behavior='tags']");
  Array.from(tag_inputs).forEach((input)=> {
    new Tagify(input, {
      // enforceWhitelist : true,
      delimiters       : ",|،",
      // whitelist        : ["The Shawshank Redemption", "The Godfather", "The Godfather: Part II", "The Dark Knight", "12 Angry Men", "Schindler's List", "Pulp Fiction", "The Lord of the Rings: The Return of the King", "The Good, the Bad and the Ugly", "Fight Club", "The Lord of the Rings: The Fellowship of the Ring", "Star Wars: Episode V - The Empire Strikes Back", "Forrest Gump", "Inception", "The Lord of the Rings: The Two Towers", "One Flew Over the Cuckoo's Nest", "Goodfellas", "The Matrix", "Seven Samurai", "Star Wars: Episode IV - A New Hope", "City of God", "Se7en", "The Silence of the Lambs", "It's a Wonderful Life", "The Usual Suspects", "Life Is Beautiful", "Léon: The Professional", "Spirited Away", "Saving Private Ryan", "La La Land", "Once Upon a Time in the West", "American History X", "Interstellar", "Casablanca", "Psycho", "City Lights", "The Green Mile", "Raiders of the Lost Ark", "The Intouchables", "Modern Times", "Rear Window", "The Pianist", "The Departed", "Terminator 2: Judgment Day", "Back to the Future", "Whiplash", "Gladiator", "Memento", "Apocalypse Now", "The Prestige", "The Lion King", "Alien", "Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb", "Sunset Boulevard", "The Great Dictator", "Cinema Paradiso", "The Lives of Others", "Paths of Glory", "Grave of the Fireflies", "Django Unchained", "The Shining", "WALL·E", "American Beauty", "The Dark Knight Rises", "Princess Mononoke", "Aliens", "Oldboy", "Once Upon a Time in America", "Citizen Kane", "Das Boot", "Witness for the Prosecution", "North by Northwest", "Vertigo", "Star Wars: Episode VI - Return of the Jedi", "Reservoir Dogs", "M", "Braveheart", "Amélie", "Requiem for a Dream", "A Clockwork Orange", "Taxi Driver", "Lawrence of Arabia", "Like Stars on Earth", "Double Indemnity", "To Kill a Mockingbird", "Eternal Sunshine of the Spotless Mind", "Toy Story 3", "Amadeus", "My Father and My Son", "Full Metal Jacket", "The Sting", "2001: A Space Odyssey", "Singin' in the Rain", "Bicycle Thieves", "Toy Story", "Dangal", "The Kid", "Inglourious Basterds", "Snatch", "Monty Python and the Holy Grail", "Hacksaw Ridge", "3 Idiots", "L.A. Confidential", "For a Few Dollars More", "Scarface", "Rashomon", "The Apartment", "The Hunt", "Good Will Hunting", "Indiana Jones and the Last Crusade", "A Separation", "Metropolis", "Yojimbo", "All About Eve", "Batman Begins", "Up", "Some Like It Hot", "The Treasure of the Sierra Madre", "Unforgiven", "Downfall", "Raging Bull", "The Third Man", "Die Hard", "Children of Heaven", "The Great Escape", "Heat", "Chinatown", "Inside Out", "Pan's Labyrinth", "Ikiru", "My Neighbor Totoro", "On the Waterfront", "Room", "Ran", "The Gold Rush", "The Secret in Their Eyes", "The Bridge on the River Kwai", "Blade Runner", "Mr. Smith Goes to Washington", "The Seventh Seal", "Howl's Moving Castle", "Lock, Stock and Two Smoking Barrels", "Judgment at Nuremberg", "Casino", "The Bandit", "Incendies", "A Beautiful Mind", "A Wednesday", "The General", "The Elephant Man", "Wild Strawberries", "Arrival", "V for Vendetta", "Warrior", "The Wolf of Wall Street", "Manchester by the Sea", "Sunrise", "The Passion of Joan of Arc", "Gran Torino", "Rang De Basanti", "Trainspotting", "Dial M for Murder", "The Big Lebowski", "The Deer Hunter", "Tokyo Story", "Gone with the Wind", "Fargo", "Finding Nemo", "The Sixth Sense", "The Thing", "Hera Pheri", "Cool Hand Luke", "Andaz Apna Apna", "Rebecca", "No Country for Old Men", "How to Train Your Dragon", "Munna Bhai M.B.B.S.", "Sholay", "Kill Bill: Vol. 1", "Into the Wild", "Mary and Max", "Gone Girl", "There Will Be Blood", "Come and See", "It Happened One Night", "Life of Brian", "Rush", "Hotel Rwanda", "Platoon", "Shutter Island", "Network", "The Wages of Fear", "Stand by Me", "Wild Tales", "In the Name of the Father", "Spotlight", "Star Wars: The Force Awakens", "The Nights of Cabiria", "The 400 Blows", "Butch Cassidy and the Sundance Kid", "Mad Max: Fury Road", "The Maltese Falcon", "12 Years a Slave", "Ben-Hur", "The Grand Budapest Hotel", "Persona", "Million Dollar Baby", "Amores Perros", "Jurassic Park", "The Princess Bride", "Hachi: A Dog's Tale", "Memories of Murder", "Stalker", "Nausicaä of the Valley of the Wind", "Drishyam", "The Truman Show", "The Grapes of Wrath", "Before Sunrise", "Touch of Evil", "Annie Hall", "The Message", "Rocky", "Gandhi", "Harry Potter and the Deathly Hallows: Part 2", "The Bourne Ultimatum", "Diabolique", "Donnie Darko", "Monsters, Inc.", "Prisoners", "8½", "The Terminator", "The Wizard of Oz", "Catch Me If You Can", "Groundhog Day", "Twelve Monkeys", "Zootopia", "La Haine", "Barry Lyndon", "Jaws", "The Best Years of Our Lives", "Infernal Affairs", "Udaan", "The Battle of Algiers", "Strangers on a Train", "Dog Day Afternoon", "Sin City", "Kind Hearts and Coronets", "Gangs of Wasseypur", "The Help"],
      originalInputValueFormat: valuesArr => valuesArr.map(item => item.value).join(','),
      callbacks        : {
        add    : console.log,  // callback when adding a tag
        remove : console.log   // callback when removing a tag
      }
    })
  });

  [...document.querySelectorAll('[data-bs-toggle="tooltip"]')]
    .map(node => new Tooltip(node));
  [...document.querySelectorAll('[data-bs-toggle="dropdown"]')]
    .map(node => new Dropdown(node));
  [...document.querySelectorAll('[data-bs-toggle="tab"]')]
    .map(node => new Tab(node));
});


import "../javascripts/intelTel"
import "../javascripts/dropdown"
import "../javascripts/contact"
import "../javascripts/contact-user-widget"
import "../javascripts/landing_animation"

import "../javascripts/user_autocomplete"
